<template>
  <div>
    <CsvImportModal 
    ref="csvUploaderModal" 
    :baseData="dataGenerateCSV" 
    @on-generate-success="handleGenerateSuccess"
    @item-ids-data="handleIdItem" 
    @on-save-success="tableDataItem"
     />
    <AddContentModal 
    ref="addContentModalRef" 
    @on-save-success="tableDataItem" />

    <div class="bg-white flex-col justify-between items-center p-4 shadow-sm rounded-lg mt-4">
      <div>
        <label class="font-bold text-lg leading-5 mb-3">SmartPin Content List</label>
      </div>
      <div class="bg-gray-50 p-3 rounded-lg text-gray-800">
        <label class="text-base font-semibold mb-1"> <i class="fa-solid fa-circle-info mr-2"></i> Only eligible content
          is displayed to users.</label>
        <p class="text-sm font-normal mb-1">Content must be Visible, Active, For Sale, and Ready to Consume, and is
          available only within the selected access radius.</p>
      </div>
    </div>

    <div class="overflow-x-auto relative bg-white px-4 space-y-5 ">
      <div class="flex justify-between items-center w-full space-y-4">
        <div class="relative w-96">
          <i class="fa-solid fa-magnifying-glass text-gray-400 text-base absolute top-3 left-3"></i>
          <input placeholder="Search by Book Name"
            class="search-input p-2.5 pl-5 mb-1 w-full text-sm border rounded-lg" type="search"
            v-model="searchItemQuery" @input="onSearch" @keyup.enter="onSearch" />
        </div>
        <div class="flex space-x-3">
          <Button @click="$refs.csvUploaderModal.openModal()" class="flex border space-x-2 justify-center items-start"
            variant="outlined" color="alternative" size="sm">
            <div class="text-xs text-gray-700 flex justify-center items-center">Import CSV</div>
          </Button>
          <Button @click="$refs.addContentModalRef.openModal()" class="flex border space-x-2 justify-center items-start"
            variant="default" size="sm">
            <div class="text-xs flex text-white justify-center items-center">Add Content</div>
          </Button>
        </div>

      </div>

      <div class="rounded-xl overflow-auto mb-4 relative border-t border-b border-l border-r">
        <div v-if="isLoadingLocationItems" class="
 left-0 top-0 bottom-0 right-0 w-full h-full absolute bg-white
  ">
          <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center">
            <svg class="h-26 w-16 animate-spin text-blue-600 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none"
              viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"></circle>
              <path d="M12 2 A 10 10 0 0 1 22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path>
            </svg>
          </div>
        </div>
        <table class="w-full text-sm text-left text-gray-500">
          <thead class="text-xs text-gray-700 uppercase bg-gray-50">
            <tr>
              <th scope="col" class="px-6 py-3">No</th>
              <th scope="col" class="px-6 py-3">image</th>
              <th scope="col" class="px-6 py-3">book name</th>
              <th scope="col" class="px-6 py-3">type</th>
              <th scope="col" class="px-6 py-3"></th>
            </tr>
          </thead>
          <tbody>

            <tr v-for="(item, index) in locationItems" :key="item.id"
              :class="{ 'border-b': index !== locationItems.length - 1 }" class="bg-white  hover:bg-gray-50">

              <td class="px-6 py-2.5 font-medium text-gray-900"> {{ (currentPageItem - 1) * limitItem + index + 1 }}
              </td>
              <td class="px-6 py-2.5 font-medium text-gray-900">
                <img v-if="item.thumb_image_normal" class="h-10 w-10 object-cover rounded-none "
                  :src="'https://ebooks.gramedia.com/ebook-covers/' + removeBucket(item.thumb_image_normal)">
                <img v-else :src="DefaultImage" class="h-10 w-10 object-cover rounded-none" alt="empty thumb" />
              </td>
              <td class="px-6 py-2.5">{{ item.name }}</td>
              <td class="px-6 py-2.5 capitalize">{{ item.item_type || item.type }}</td>
              <td class="px-6 py-2.5 capitalize">
                <Button @click="deleteItem(item)" class="flex border space-x-0 justify-center items-start"
                  variant="outlined" color="alternative" size="sm">
                  <div class="text-xs text-gray-700 flex justify-center items-center">
                    <svg class="w-5 h-5 mr-1 text-gray-800 dark:text-white" aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z" />
                    </svg>
                    Remove
                  </div>
                </Button>
              </td>
            </tr>
            <tr v-if="locationItems.length === 0 && !searchItemQuery">

              <td colspan="5">
                <div class="flex flex-col justify-center space-y-3 items-center p-4">
                  <img :src="noItem" class="w-12 h-12" />
                  <h5 class="font-bold leading-6 text-gray-900">No SmartPin Content Yet</h5>
                  <p class="text-gray-500 text-sm mt-2">Add content to create your SmartPin Content List.</p>
                </div>
              </td>
            </tr>
             <tr v-if="locationItems.length === 0 && searchItemQuery">

              <td colspan="5">
                <div class="flex flex-col justify-center space-y-3 items-center p-4">
                  <p class="text-gray-500 text-sm mt-2">No data available.</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="totalLocationItems / limitItem > 1"
        class="flex bg-white items-start justify-between ml-0 pt-0 align-middle px-0">
        <div class="font-semibold mt-1">
          <span class="text-gray-500 font-normal">Showing </span> {{ currentPageItem }}-{{ limitItem }} <span
            class="text-gray-500 font-normal">of</span> {{ parseInt(totalLocationItems) }}
        </div>
        <div class="mb-2">
          <t-pagination :total-items="Number(totalLocationItems)" :per-page="limitItem" v-model="currentPageItem"
            class="rounded-lg" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Button from '@/components/ui/Button'
import CsvImportModal from '../../components/smart-pin/CsvImportModal.vue'
import AddContentModal from '../../components/smart-pin/AddContentModal.vue'

import { mapActions, mapState } from 'vuex';
import noItem from '../../assets/img/no_smartPint.png'
import DefaultImage from '../../assets/img/emptyitem.png'
import { EventBus } from '../../event-bus.js'

export default {
  name: 'DetailLocation',
  components: {
    Button,
    CsvImportModal,
    AddContentModal
  },
  data() {
    return {
      locationDetail: [],
      isLoading: false,
      limitType: 'limit',
      isError: false,
      progressLimit: 25,
      isCopied: false,
      progress: 0,
      noItem: noItem,
      DefaultImage: DefaultImage,
      dataGenerateCSV: [],
      dataSelectItem:[],
      validateObject: [],
      mergedData: [],
      isErrorValidate: false,
      isLoadingProgress: false,
      file: null,
      csvDataRaw: [],
      searchValidationQuery:'',
      originalValidationData: [],
      searchItemQuery: '',
      currentPageItem: 1,
      searchTimeout: null,
      limitItem: 10,
      fileName: '',
      fileSize: null,
      disabled: false,
    };
  },
  watch: {
    currentPageItem: function () {
      this.tableDataItem();
    },
  },
  computed: {
    ...mapState('smartpin', {
      locationItems: state => state.locationItems,
      isLoadingLocationItems: state => state.isLoadingLocationItems,
      totalLocationItems: state => state.totalLocationItems,
    })
  },
  mounted() {
    if (!this.searchItemQuery) {
      this.tableDataItem()
    }
  },
  methods: {
    ...mapActions('smartpin', ['validateLocationItems', 'fetchLocationItems', 'addItemLocation','getLocationById']),

    openModalCSV() {
      this.$refs.openModalUploadCSV.show();
    },
    async tableDataItem() {
      try {
        await this.fetchLocationItems({
          id: this.$route.params.id,
          q: this.searchItemQuery,
          limit: this.limitItem,
          page: this.currentPageItem
        });
      } catch (error) {
        console.error("Gagal render tabel:", error);
      }
    },
    handleGenerateSuccess(resultData) {
      console.log("resultData", resultData);
    },
      async fetchDetailData(id) {
      this.isLoading = true;
      this.isError = false;
    
      try {
        const response = await this.getLocationById(id);
        this.locationDetail = response.data; 
        this.progressLimit = this.locationDetail.reading_progress
      } catch (error) {
        this.isError = true;
        console.error("Gagal merender detail:", error);
      } finally {
        this.isLoading = false;
      }
    },
    async handleIdItem(ids) {
      console.log("ID yang dikirim:", ids);

      const payload = {
        item_ids: ids
      };

      try {
        const response = await this.validateLocationItems(payload);
        this.processValidationResult(response);

      } catch (error) {
        console.error("Gagal melakukan request API:", error);
        if (error && error.data && Array.isArray(error.data)) {
          console.log("Memproses JSON error dari Backend...");
          this.processValidationResult(error);
        }
      }
    },

    onSearch(event) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      if (event && event.key === 'Enter') {
        this.currentPageItem = 1;
        this.tableDataItem();
        return;
      }

      this.searchTimeout = setTimeout(() => {
        this.currentPageItem = 1;
        this.tableDataItem();
      }, 800);
    },
    removeBucket(str) {
      if (str && str.substring(0, 6) == "images") {
        return str.substring(9);
      } else {
        return str ?? 'default.png';
      }
    },
   async deleteItem(item) {
      const payload = {
        id: this.$route.params.id,
        type: "delete",
        item_ids: [item.id]
      };
       if (this.locationItems.length === 1 && this.currentPageItem > 1) {
           this.currentPageItem--; 
        }
     try {
        const result = await this.addItemLocation(payload);
        console.log("Berhasil menghapus item:", result);
        const titleCase = item.name.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
        EventBus.$emit('show-toast', {
          message: `${titleCase} has been removed.`,
          type: 'success'
        });
          const locationId = this.$route.params.id; 
          if (locationId) {
            this.fetchDetailData(locationId);
          }
        this.tableDataItem();
      } catch (error) {
        console.error("Gagal saat mencoba deleteItem:", error);
      }
    },
     filterValidationSearch() {
      if (!this.searchValidationQuery) {
        this.dataGenerateCSV = {
          ...this.dataGenerateCSV, 
          data: [...this.originalValidationData]
        };
        return;
      }

      const query = this.searchValidationQuery.toLowerCase();

      const filteredData = this.originalValidationData.filter(item => {
        const name = (item.name || '').toLowerCase();
        const id = String(item.id || '').toLowerCase();
        
        return name.includes(query) || id.includes(query);
      });

      this.dataGenerateCSV = {
        ...this.dataGenerateCSV,
        data: filteredData
      };
    },
    processValidationResult(result) {
      if (result && Array.isArray(result.data)) {
        this.dataGenerateCSV = result
           if (result.data && Array.isArray(result.data)) {
          this.originalValidationData = [...result.data];
        } else {
          this.originalValidationData = [];
        }
      } else {
        console.log("Format respons tidak sesuai dengan yang diharapkan:", result);
      }
    },
      clearValidationSearch() {
      this.searchValidationQuery = '';
      this.filterValidationSearch();
    },
  }
}
</script>
<style scoped>
.search-input::-webkit-search-cancel-button {
  cursor: pointer !important;
}
</style>